import { PlanSibling } from '@anm/api/modules/pricing';
import noop from 'lodash/fp/noop';
import { FC } from 'react';

import PlanFeatures from '../PlanFeatures';
import PlanPeriodButtonBlock, { PlanPeriodButtonBlockProps } from '../PlanPeriodButtonBlock';

import { PricingTableProps } from '.';
import { Column, Medium, PricingTableWrapper, Row, Top } from './Wrapper';
export * from './types';

type DesktopTableProps = PricingTableProps &
  Pick<PlanPeriodButtonBlockProps, 'siblingDropdownOptions'> & {
    onSiblingChange?: (sibling: PlanSibling) => void;
  };
const DesktopTable: FC<DesktopTableProps> = ({
  list,
  siblingDropdownOptions,
  onGetPlanClick = noop,
  onSiblingChange
}) => {
  const maxFeaturesLength = Math.max(...list.map(({ features }) => features.length));
  return (
    <PricingTableWrapper>
      <Row>
        {list.map(
          ({
            id,
            variant,
            planName,
            periodName,
            discount,
            isAnnual,
            isSamePlan,
            description,
            disabled,
            isSamePeriod,
            price,
            sibling,
            showPlanBottomButton
          }) => (
            <Column key={id}>
              <Top>
                <PlanPeriodButtonBlock
                  {...{
                    price,
                    variant,
                    isAnnual,
                    planName,
                    sibling,
                    discount,
                    periodName,
                    disabled,
                    isSamePlan,
                    description,
                    isSamePeriod,

                    ...(sibling && { siblingDropdownOptions, onSiblingChange })
                  }}
                  showPlanButton={showPlanBottomButton}
                  onGetPlanClick={() => onGetPlanClick(id)}
                />
              </Top>
            </Column>
          )
        )}
      </Row>

      {Array.from({ length: maxFeaturesLength }).map((_, i) => (
        <Row key={i}>
          <Medium>
            {list.map(({ id, features }) => (
              <Column key={id}>
                <PlanFeatures title={features[i].title} list={features[i].features} />
              </Column>
            ))}
          </Medium>
        </Row>
      ))}
    </PricingTableWrapper>
  );
};
export default DesktopTable;
